import logo from './logo.svg';
import './App.css';
import store from './store';
import {Provider} from 'react-redux';
import Navheader from './Components/Navheader';
import Background from './Components/Background';
import Element from './Components/Element';
import styles from './Components/styles.module.scss';
import Button from './Components/Button';
import Card from './Components/Card';
import Footer from './Components/Footer';
import Vid from './Components/Vid';
import PasswordInput from './Components/PasswordInput';
function Passwords(props) {


  const gameArray = props.games;
  const gameCardsArray = props.gameCards;
   const horrorGameArray = props.horrorGames;

  let elementArray = [];

  for(let i = 0; i < 3; i++){
    elementArray.push(<Element halloween={props.halloween} xmas={props.xmas} key={i} height={"33P"} background={i}></Element>);
  }

console.log(elementArray);
  return (

    <div className="App"
    style={{
      width: '100%',
      background:'black',
      overflowX: "hidden"
    }}>
    <Background halloween={props.halloween} xmas={props.xmas}></Background>
    <Element halloween={props.halloween} xmas={props.xmas} height={"10P"} background={2}></Element>
    <Element halloween={props.halloween} xmas={props.xmas} height={"90P"} background={8} flexColumn={true}>
       <div className={`${styles[`h1`]}`}>Input Passwords</div>
      <PasswordInput halloween={props.halloween} xmas={props.xmas}></PasswordInput>
       
   
    </Element>
    

        

    <Navheader halloween={props.halloween} xmas={props.xmas} games={gameArray} horrorGames={horrorGameArray}></Navheader>
   
    </div>

    
  );
}

export default Passwords;
